
import { ParkdCardsResponse, SagaGenerator, UsersResponse } from "types";
import { all, put, takeEvery } from "redux-saga/effects";
import { callApi } from "root/appSaga";
import { Api } from "api";
import { generateAllQueryParams } from "myParkdUtils/utils";
import { parkdCardsSliceActions } from "./parkdCardsSlice";


export function* parkdCardsSaga(): SagaGenerator {
    return yield all([
        takeEvery(parkdCardsSliceActions.getParkdCards, getParkdCards),
    ]);
}

export function* getParkdCards(params: ReturnType<typeof parkdCardsSliceActions.getParkdCards>): SagaGenerator {
    try {
        const queryParams = generateAllQueryParams(params.payload);
        const pagedCards: ParkdCardsResponse = yield callApi(Api.getCompanyParkdCards, queryParams);
        const { parkingCards, totalElements, totalPages } = pagedCards;
        yield put(parkdCardsSliceActions.getParkdCardsCompleted({ parkingCards, totalElements, totalPages }));
    } catch (error) {
        yield put(parkdCardsSliceActions.getParkdCardsError({ error }));
        console.error(error);
    }
}
